import React from 'react';

const Footer = () => (
  <footer className="px-4 py-8 border-t border-white/10">
    <div className="max-w-6xl mx-auto text-center">
      <p className="text-white/60">© 2026 Chanuka Keerthisigha. Built with React. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
